import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const CircleArrowsIcon: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--phone')}
    viewBox="0 0 15.7 15.83"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <path
      fill="#17171d"
      d="
        M3.73,1.09
        c.32,0,.56.06.56.17,0,.29,1.48,3.53,1.49,3.82
        s-1,1.28-1.28,1.57,1.92,2.82,2,2.87,2.26,2,2.77,2
        a.1.1,0,0,0,.07,0
        c.29-.29,1.28-1.26,1.58-1.26
        h0
        c.29,0,3.51,1.52,3.8,1.54
        s.19,1.68-.37,2.23
        a3.69,3.69,0,0,1-2.54.89,7.92,7.92,0,0,1-4.6-1.81,13.46,13.46,0,0,1-2.31-2
        h0
        a13.44,13.44,0,0,1-2-2.33
        c-3-4.26-1.3-6.69-.82-7.16
        a2.71,2.71,0,0,1,1.67-.5
        m0-1
        A3.61,3.61,0,0,0,1.36.88
        C.21,2-.93,5.06,2,9.29
        a14.25,14.25,0,0,0,2,2.39
        l0,.08.08.06,0,0,0,0
        a14.29,14.29,0,0,0,2.37,2,8.94,8.94,0,0,0,5.16,2
        A4.66,4.66,0,0,0,15,14.74
        a3.64,3.64,0,0,0,.7-3.18,1.13,1.13,0,0,0-.87-.74
        c-.24-.08-1.1-.45-1.68-.7
        a8.41,8.41,0,0,0-2.25-.85
        h-.06
        c-.42,0-.83.18-1.81,1.09
        a23.24,23.24,0,0,1-1.9-1.54
        A23.64,23.64,0,0,1,5.66,6.89
        C6.54,6,6.8,5.53,6.78,5
        A8.39,8.39,0,0,0,6,2.79
        c-.24-.58-.61-1.45-.68-1.69
        S5,.09,3.73.09
        Z
      "
      transform="translate(-0.15 -0.09)"
    />
  </svg>
);

export default CircleArrowsIcon;
